let scrollingStatusMonitorInitialised = false;

export function initScrollingStatus() {

	if (scrollingStatusMonitorInitialised) {
		return;
	}

	window.addEventListener('scroll', () => {
		if (window.scrollY > 5) {
			document.body.classList.add('body--scrolled');
		} else {
			document.body.classList.remove('body--scrolled');
		}
	})

}
